<template>
  <div>
    <b-form-group
        label="Company"
        label-for="companyName"
        class="mb-3"
        label-class="required"
        description="Company's name as stated in your legal"
    >
      <b-form-input
          id="companyName"
          v-model="$v.form.company_name.$model"
          type="text"
          :state="validateState('form', 'company_name')"
          placeholder="Company Name"
      ></b-form-input>
      <b-form-invalid-feedback>
        This is a required field and must between 5 - 70 characters.
      </b-form-invalid-feedback>
    </b-form-group>
    <b-row class="mb-3">
      <b-col>
        <b-form-group
            label="Username"
            label-for="username"
            label-class="required"
            description="This will be your login credential"
        >
          <b-form-input
              id="username"
              v-model="$v.form.username.$model"
              type="text"
              placeholder="username"
              :state="validateState('form','username')"
          ></b-form-input>
          <b-form-invalid-feedback>
            This is a required field and must between 5 - 30 characters.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
            label="Email"
            label-for="email"
            label-class="required"
            description="We will send an activation link there"
        >
          <b-form-input
              id="email"
              v-model="$v.form.user_mail.$model"
              type="email"
              placeholder="Email Address"
              :state="validateState('form','user_mail')"
          ></b-form-input>
          <b-form-invalid-feedback>
            This is a required field, must between 5 - 70 characters and a valid email.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <b-form-group
            label="NIB"
            label-for="NIB"
            label-class="required"
            description="Nomor Induk Berusaha"
        >
          <b-form-input
              id="NIB"
              v-model="$v.form.NIB.$model"
              type="text"
              placeholder="NIB"
              :state="validateState('form', 'NIB')"
          ></b-form-input>
          <b-form-invalid-feedback>
            This is a required field and must be at least 13 characters.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
            label="NPWP"
            label-for="NPWP"
            label-class="required"
            description="Nomor Pokok Wajib Pajak"
        >
          <b-form-input
              id="NPWP"
              v-model="$v.form.NPWP.$model"
              type="text"
              placeholder="NPWP"
              :state="validateState('form', 'NPWP')"
          ></b-form-input>
          <b-form-invalid-feedback>
            This is a required field and must be valid NPWP.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <!--   NIB UPLOAD   -->
    <b-form-group
        label="NIB"
        label-for="NIB_img"
        label-class="required"
        description="Clear scan of your NIB document. JPEG or PNG only"
    >
      <b-form-file
          id="NIB_img"
          v-model="file.nib"
          accept="image/jpeg, image/png"
          :state="file.nib ===null ? null : Boolean(file.nib)"
          placeholder="Drop NIB here..."
          drop-placeholder="Drop NIB here..."
      ></b-form-file>
        <b-form-invalid-feedback>
          This is a required field
        </b-form-invalid-feedback>
    </b-form-group>
    <!--   NPWP UPLOAD   -->
    <b-form-group
        label="NPWP"
        label-for="NPWP_img"
        label-class="required"
        description="Clear scan of your NPWP document. JPEG or PNG only"
    >
      <b-form-file
          id="NPWP_img"
          v-model="file.npwp"
          accept="image/jpeg, image/png"
          :state="file.npwp ===null ? null : Boolean(file.npwp)"
          placeholder="Drop NPWP here..."
          drop-placeholder="Drop NPWP here..."
      ></b-form-file>
      <b-form-invalid-feedback>
        This is a required field
      </b-form-invalid-feedback>
    </b-form-group>
    <div class="row">
      <!-- /.col -->
      <div class="col-12">
        <b-button type="submit" variant="primary" :disabled="isSubmitting" @click="submit"
                  class="btn btn-primary btn-block">
          Submit!
          <b-spinner v-if="isSubmitting" small></b-spinner>
        </b-button>
      </div>
      <!-- /.col -->
    </div>
  </div>
</template>

<script>
import {validationMixin} from "vuelidate";
import {required, minLength, maxLength, numeric, email} from "vuelidate/lib/validators";
import {formValidation} from "@/mixins/formValidation";
import {BFormFile, BSpinner,} from 'bootstrap-vue';
import {upload} from "@/services/utils";
import {registerMember} from "@/services/members";
import {hasOwnProperty} from "@/helpers/Utils";

export default {
  name: "RegistrationForm",
  mixins: [validationMixin, formValidation],
  components: {
    BFormFile, BSpinner,
  },
  validations: {
    form: {
      company_name: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(70),
      },
      NPWP: {
        required,
        // isValidNPWP,
        minLength: minLength(5),
        maxLength: maxLength(20),
      },
      NIB: {
        required,
        numeric,
        minLength: minLength(13),
        maxLength: maxLength(13),
      },
      username: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(30),
      },
      user_mail: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(70),
        email,
      },
    }
  },
  data: () => ({
    form: {
      company_name: '',
      NPWP: '',
      NIB: '',
      npwp_img: null,
      nib_img: null,
      username: '',
      user_mail: '',
    },
    file: {
      npwp: null,
      nib: null,
    },
    isSubmitting: false,
  }),
  methods: {
    async submit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        this.$bvToast.toast(`Missing required information!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      if (!this.file.nib || !this.file.npwp) {
        this.$bvToast.toast(`Please attached both NPWP & NIB`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      try {
        this.isSubmitting = true;
        if (this.file.nib) {
          if (this.file.nib.size > 1_000_000) {
            this.$bvToast.toast(`NIB image too large! Max size: 1MB only`, {
              title: 'Error!',
              autoHideDelay: 1500,
              variant: 'danger',
            })
            return;
          }
          this.form.nib_img = await this.uploadImage(this.file.nib)
        }
        console.log('Upload NIB success')
        if (this.file.npwp) {
          if (this.file.npwp.size > 1_000_000) {
            this.$bvToast.toast(`NPWP image too large! Max size: 1MB only`, {
              title: 'Error!',
              autoHideDelay: 1500,
              variant: 'danger',
            })
            return;
          }
          this.form.npwp_img = await this.uploadImage(this.file.npwp)
        }
        console.log('Upload NPWP success')
        if (typeof this.form.nib_img !== 'string') {
          this.form.nib_img = null;
        }
        if (typeof this.form.npwp_img !== 'string') {
          this.form.npwp_img = null;
        }
        const {data: {data: {user}}} = await registerMember(this.form);
        this.$bvToast.toast(`Member saved Success!`, {
          title: 'Congratulation!',
          autoHideDelay: 1500,
          variant: 'success',
        })
        this.clearForm();
        this.isSubmitting = false;
        this.$emit('registered', { user })
      } catch (e) {
        this.isSubmitting = false;
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }
      }
    },
    async uploadImage(file) {
      const {data: {data: {path}}} = await upload({file});
      return path;
    },
    clearForm() {
      this.form = {
        company_name: '',
        NPWP: '',
        NIB: '',
        npwp_img: null,
        nib_img: null,
        username: '',
        user_mail: '',
      }
      this.file = {
        npwp: null,
        nib: null,
      }
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
  },
}
</script>

<style scoped>

</style>
